import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api.js';
import { PageHeader } from '@/components/PageHeader.jsx';
import { Button } from '@/components/ui/Button.jsx';
import { Badge } from '@/components/ui/Badge.jsx';
import { DataTable } from '@/components/DataTable.jsx';
import { formatLKR, formatDate } from '@/lib/format.js';
import { Plus, Eye } from 'lucide-react';

export default function EmployeesPage() {
  const navigate = useNavigate();
  const { data = [], isLoading } = useQuery({ queryKey: ['employees', {}], queryFn: () => api.get('/employees') });

  const columns = [
    { key: 'emp_no', header: 'Emp No', sortable: true, className: 'font-mono' },
    { key: 'full_name', header: 'Name', sortable: true,
      render: (r) => (
        <Link to={`/employees/${r.id}`} className="text-brand-600 hover:underline">{r.full_name}</Link>
      ),
    },
    { key: 'department_name', header: 'Department', sortable: true },
    { key: 'designation_name', header: 'Designation', sortable: true },
    { key: 'employment_type', header: 'Type' },
    { key: 'join_date', header: 'Join Date', sortable: true, render: (r) => formatDate(r.join_date), className: 'font-mono' },
    { key: 'basic_salary_cents', header: 'Basic',
      accessor: (r) => r.basic_salary_cents,
      render: (r) => formatLKR(r.basic_salary_cents),
      className: 'text-right tabular-nums font-mono', headClassName: 'text-right' },
    { key: 'status', header: 'Status',
      render: (r) => <Badge variant={r.status === 'active' ? 'success' : r.status === 'inactive' ? 'warning' : 'danger'}>{r.status}</Badge> },
    { key: '__a', header: '', className: 'w-20 text-right',
      render: (r) => <Button variant="ghost" size="icon" onClick={() => navigate(`/employees/${r.id}`)}><Eye className="h-4 w-4" /></Button> },
  ];

  return (
    <div className="space-y-5">
      <PageHeader title="Employees" description="Manage employee master data"
        actions={<Button asChild><Link to="/employees/new"><Plus className="h-4 w-4" />New Employee</Link></Button>}
      />
      <DataTable columns={columns} data={data} loading={isLoading} exportFilename="employees.csv" pageSize={15} />
    </div>
  );
}
